import axios, { AxiosResponse } from 'axios';

const zmenaHeslauApi = async (passold: string, passnew: string, lang: string) => {
    const { status }: AxiosResponse<string> = await axios({
        method: 'POST',
        url: 'Portal/Password',
        data: {
            // iduzivatele: 0, zatial sa nepouziva
            passold,
            passnew,
            lang
        }
    });
    return status;
};

export default zmenaHeslauApi;
